// extracted by mini-css-extract-plugin
export var heading = "ComponentCoverageListItem-module--heading--291d7";
export var icon = "ComponentCoverageListItem-module--icon--f9b87";
export var text = "ComponentCoverageListItem-module--text--0004d";